import {
  PARTNERS_COVERAGE_COLUMN_KEYS,
  PARTNERS_COVERAGE_COLUMN_TITLES,
} from '../../../../configs/coverageTables'

import { CoverageTableColgroup } from './CoverageTableColgroup'

import styles from './CoverageTable.module.scss'

export const CoverageTableHeader = () => {
  return (
    <div className={styles.root}>
      <div className={styles.plateSpacer} />

      <div className={styles.card}>
        <table className={styles.table}>
          <CoverageTableColgroup />
          <thead>
            <tr>
              <th className={styles.headerLabel} />
              {PARTNERS_COVERAGE_COLUMN_KEYS.map((columnKey) => (
                <th key={columnKey} className={styles.headerCell} scope="col">
                  {PARTNERS_COVERAGE_COLUMN_TITLES[columnKey]}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
    </div>
  )
}
